module.exports = __webpack_public_path__ + "img/check-success.884509ff.svg";